<template>
    <div class="air-container air-container-subscribe-secret-pop " :class="showAir ? 'air-container_active' :''">
        <div class="popup-air " :class="showAir ? ' popup-air_active' :''">
            <div class="air-close" @click="close()"></div>
            <div class="subscription-modal">
                <div class="picture-wrapper">
                    <picture class="subscription-modal__image">
                        <img :src="'/img/secret-2026-1-popup.webp'" alt="Подписаться">
                    </picture>
                    <div class="text-on-picture-wrap">
                        <div class="header-text">
                            <h3 class="subscription-modal__title">{{trans('FOR EMAIL SUBSCRIBERS ONLY')}}.<br />{{trans('PASSWORD ACCESS ONLY')}}.</h3>
                        </div>
                        <div class="main-text">
                            <h2 class="subscription-modal__title secret-header">SECRET DROP</h2>
                            <h3 class="subscription-modal__title">{{trans('At extremely accessible prices')}}<br />{{trans('starting from $40')}}</h3>
                        </div>
                        <div class="footer-text">
                            <h3 v-if="this.$store.state.settings.site_id == 1" class="subscription-modal__title">{{trans('ONLY UNTIL MARCH 5TH.')}}</h3>
                            <h3 v-if="this.$store.state.settings.site_id == 2" class="subscription-modal__title">{{trans('ONLY UNTIL MARCH 14')}}</h3>
                        </div>
                    </div>
                </div>
                <div class="form-header">
                    <h3 class="subscription-modal__title">{{trans('Subscribe to stay updated on new collections, special offers')}},</h3>
                    <h3 class="subscription-modal__title text-error text-red">{{trans('and secret drops with limited access')}}</h3>
                </div>

                <form class="subscription-modal__form" style="margin-top: 20px;flex-direction:column;">

                    <div class="input-wrapper">
                        <input v-model="email" type="text" name="email" placeholder="email" class="input-element input-wrapper__element-inp input-wrapper__element-inp-js">
                    </div>

                    <div v-if="genderSpecify" class="input-wrapper">
                        <div class="select-size">
                            <div class="select-size__header input-wrapper__element-inp" @click="show_gender = !show_gender"
                                 :class="show_gender ? 'select-active':''">
                                <p class="select-size__header-title sex-select__title"
                                   v-if="gender">
                                    {{ gender === 1 ? trans('Male gender') : trans('Female gender') }}</p>
                                <p class="select-size__header-title sex-select__title placeholder"
                                   v-if="!gender">{{ trans("Gender") }}</p>
                                <img class="select-size__header-img" src="https://batnorton.com/img/svg/select-ar.svg"
                                     alt="">
                            </div>
                            <div class="select-size__body">
                                <ul class="list select-size__list" v-show="show_gender"
                                    :class="show_gender ? 'select-size__body_displayed':''">
                                    <li @click="setGender(1)" class="list__element select-size__element">
                                        <span class="select-size__element-value">{{ trans('Male gender') }}</span>
                                        <span class="select-size__element-value"></span>
                                    </li>
                                    <li @click="setGender(2)" class="list__element select-size__element">
                                        <span class="select-size__element-value">{{ trans('Female gender') }}</span>
                                        <span class="select-size__element-value"></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="input-wrapper" style="margin-top: 20px">
                        <label class="input-wrapper__title input-checkbox__wrapper subscribe-form__checkbox-title">
                            <input v-model="checkbox" type="checkbox" class="input-checkbox" name="agreement" id="agreement">
                            <span>{{trans('I give my consent to receive information about news and special offers and confirm that I have read and agree to the')}} <a
                                href="/privacy-policy">{{trans('Privacy Policy')}}</a></span>
                        </label>
                    </div>

                    <button @click.prevent="subscribe" style="max-height: 42px;" class="btn btnV2 subscription-modal__button-js">
                        {{ trans("Subscribe") }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import store from '../../store.js';

export default {
    name: 'secret',
    data() {
        return {
            timeoutRu: 15,
            timeoutWorld: 15, //sec
            pause: 86400, //sec
            email:'',
            checkbox: true,
            gender: null,
            show_gender: false,
            timer: null,
            data: null,
            unwatch: null,
            unwatchVmeste: null,
            genderSpecify: false,
            lcKey: ''
        }
    },
    mounted() {
        if (this.$store.state.settings.site_id == 1) {
            this.lcKey = this.$store.state.settings.secret.key + '-air'
        } else if (this.$store.state.settings.site_id == 2) {
            this.lcKey = this.$store.state.settings.secret.key + '-air'
        }
        this.data = JSON.parse(localStorage.getItem(this.lcKey))

        if (window.location.pathname === '/secret') {
            return true
        }

        this.scheduleSubscriptionPopup()
    },
    beforeUnmount() {
        if (this.unwatchVmeste) {
            this.unwatchVmeste()
        }
    },
    watch: {
        showAir(value) {
            if (value === false) {
                clearInterval(this.timer)
            }
        }
    },
    computed: {
        time() {
            return this.$store.state.time
        },
        showAir() {
            if (this.$store.state.settings.subscription_email && !window.location.pathname.includes(`secret`) && !localStorage.getItem(this.lcKey))
                return this.$store.state.showSecretAir
            return false;
        },
        subscriptionTimeout() {
            return this.$store.state.settings.site_id === 1 ? this.timeoutRu : this.timeoutWorld
        }
    },
    methods: {
        waitForVmesteThenSchedule() {
            if (this.$store.state.vmestePopupDone) {
                if (!this.$store.state.promoPopupShown) {
                    store.commit('resetTime')
                    this.scheduleSubscriptionPopup()
                }
                return
            }
            this.unwatchVmeste = this.$watch(
                () => this.$store.state.vmestePopupDone,
                (done) => {
                    if (done) {
                        if (this.unwatchVmeste) {
                            this.unwatchVmeste()
                            this.unwatchVmeste = null
                        }
                        if (!this.$store.state.promoPopupShown) {
                            store.commit('resetTime')
                            this.scheduleSubscriptionPopup()
                        }
                    }
                }
            )
        },
        scheduleSubscriptionPopup() {
            if (!this.data) {
                this.startTimer()
            }

            if (this.data) {
                if ((Date.now() - this.data.time) > (this.pause * 1000)) {
                    this.startTimer()
                }
            }
        },
        startTimer() {
            this.timer = setInterval(function() {
                store.commit('increaseTime')
            }, 1000)
            this.unwatch = this.$watch('time', (value) => {
                if (value === this.subscriptionTimeout) {
                    store.commit('openSecretAir')
                }
            })
        },
        close() {
            store.commit('closeSecretAir')
            store.commit('resetTime')
            if (this.unwatch) {
                this.unwatch()
            }
            if (!this.data) {
                localStorage.setItem(this.lcKey, JSON.stringify({
                    'time': Date.now()
                }))
            }
            if(this.data && this.data.time) {
                localStorage.setItem(this.lcKey, JSON.stringify({
                    'time': new Date().setFullYear(9999).toFixed()
                }))
            }
        },
        setGender(male) {
            this.gender = male
            this.show_gender = false
        },
        validateEmail() {
            const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
            return emailRegex.test(this.email)
        },
        async subscribe() {
            let errorsExists = false
            if (this.genderSpecify && !this.gender) {
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Specify the gender'),
                    type: 'error',
                });
                errorsExists = true
            }
            if (!this.checkbox) {
                this.$notify({
                    title: this.trans('Error'),
                    text:  this.trans('You must agree to the terms and conditions'),
                    type: 'error',
                });
                errorsExists = true
            }
            if(this.email.length === 0){
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Fill in the email'),
                    type: 'error',
                });
                errorsExists = true
            }else if(!this.validateEmail()){
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Incorrect email address'),
                    type: 'error',
                });
                errorsExists = true
            }

            if (errorsExists === true) {
                return false
            }

            await axios.get('/api/v1/set-subscribe', {
                params: this.setParam({
                    email:  this.email,
                    guest:  this.$store.state.settings.guest.id,
                    gender: this.gender,
                    type: 2
                })
            })
            .then(data => {
                if(data.data.status === 'success'){
                    if (import.meta.env.MODE === 'production' && this.$store.state.settings.site_id == 1) {
                        _tmr.push({ type: 'reachGoal', id: 3290316, goal: 'subscription'})
                        ym(80128144,'reachGoal','subscription1')
                    }
                    this.close()
                    this.$notify({
                        title: this.trans('Notification'),
                        text: data.data.text,
                        type: 'success',
                    });
                    localStorage.setItem(this.lcKey, JSON.stringify({
                        'time': new Date().setFullYear(9999).toFixed(),
                        'subscribed': true
                    }))
                }
                if(data.data.status === 'error'){
                    this.$notify({
                        title: this.trans('Error'),
                        text: data.data.text,
                        type: 'error',
                    });
                }
                this.showSubscribe = false
            })
        }
    }
};
</script>

<style scoped lang="scss">
.placeholder {
    color: #757575;
    line-height: 16px;
}
.text-red {
    color: #CF4D4D;
}
.subscription-modal__button-js{
    margin-top: 10px;
}
.air-container-subscribe-secret-pop {
    .popup-air {
        padding: 20px;
        max-width: 640px;
        .air-close {
            top: 10px;
            right: 10px;
        }
        .subscription-modal {
            padding: 0;
            .picture-wrapper {
                position: relative;
                margin: -20px;
                margin-bottom: 20px;
                .text-on-picture-wrap {
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                }
                .subscription-modal__title {
                    font-size: 16px;
                    color: white;
                    text-align: center;
                    font-weight: 400;
                    line-height: 18px;
                }
                .header-text {
                    width: 80%;
                    position: absolute;
                    top: 5%;
                }
                .main-text {
                    width: 80%;
                    align-items: center;
                    h2 {
                        font-size: 34px;
                        margin-bottom: 15px;
                    }
                    h3 {
                        font-family: HelveticaNeueCyr, sans-serif;
                        line-height: 25px;
                        font-size: 34px;
                    }
                    .subscription-modal__title:first-child {
                        font-size: 34px;
                        font-weight: bold;
                    }
                    .subscription-modal__title {
                        font-size: 20px;
                    }
                }
                .footer-text {
                    align-items: flex-end;
                    width: 80;
                    position: absolute;
                    bottom: 20px;
                    .subscription-modal__title {
                        font-size: 14px;
                    }
                }
            }
            .subscription-modal__title {
                font-size: 12px;
                line-height: 16px;
                text-align: left;
                font-weight: 510;
            }
            .subscription-modal__form {
                .input-wrapper__element-inp {
                    background-color: #DFDEDE;
                }
                .subscribe-form__checkbox-title{
                    text-transform: none;
                    font-size: 12px;
                    color: #3C3C3C;
                    span {
                        padding-left: 10px;
                        a {
                            color: #3C3C3C;
                            text-decoration: underline;
                        }
                    }
                }
            }
            .subscription-modal__image {
                img {
                    height: 100%;
                }
            }
        }
    }
}
@media screen and (max-width: 768px) {
    .subscription-modal__form {
        align-items: center;
    }
    .air-container-subscribe-secret-pop {
        .popup-air {
            margin: 0 20px;
            .subscription-modal {
                .picture-wrapper {
                    .text-on-picture-wrap {
                        .header-text {
                            width: 85%;
                            .subscription-modal__title {
                                font-size: 14px;
                            }
                        }
                        .main-text {
                            width: 85%;
                            .subscription-modal__title {
                                font-size: 24px;
                                line-height: 30px;
                            }
                        }
                        .footer-text {
                            width: 85%;
                            .subscription-modal__title {
                                font-size: 12px;
                            }
                        }
                    }
                }
            }
        }
    }
    .form-header .subscription-modal__title{
        font-size: 10px !important;
    }
    .subscribe-form__checkbox-title{
        font-size: 10px !important;
    }
}
@media screen and (max-width: 599px) {
    .air-container-subscribe-secret-pop {
        .popup-air {
            margin: 0 20px;
            .subscription-modal {
                .picture-wrapper {
                    .text-on-picture-wrap {
                        .header-text {
                            width: 85%;
                            .subscription-modal__title {
                                font-size: 12px;
                            }
                        }
                        .main-text {
                            width: 85%;
                            margin-top: 30px;
                            .subscription-modal__title:first-child {
                                font-size: 20px;
                                line-height: 25px;
                            }
                            .subscription-modal__title {
                                font-size: 16px;
                                line-height: 20px;
                            }
                        }
                        .footer-text {
                            width: 85%;
                            bottom: 10px;
                            .subscription-modal__title {
                                font-size: 10px;
                            }
                        }
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 480px) {
    .air-container-subscribe-secret-pop {
        .popup-air {
            margin: 0;
            .subscription-modal {
                .picture-wrapper {
                    .text-on-picture-wrap {
                        .subscription-modal__title {
                            text-center: center;
                        }
                        .header-text {
                            width: 90%;
                            .subscription-modal__title {
                                font-size: 12px;
                            }
                        }
                        .main-text {
                            width: 90%;
                            margin-top: 30px;
                            .subscription-modal__title:first-child {
                                font-size: 18px;
                                line-height: 20px;
                            }
                            .subscription-modal__title {
                                font-size: 14px;
                            }
                        }
                        .footer-text {
                            width: 90%;
                            .subscription-modal__title {
                                font-size: 10px;
                            }
                        }
                    }
                }
            }
        }
    }
}
@media screen and (min-width: 800px) and (max-height: 800px){
    .picture-wrapper {
        height: 300px;
        img {
            object-fit: cover;
            object-position: top;
        }
    }
}
</style>
